import AlertsStore from './AlertsStore'

export default AlertsStore
